__turbopack_context__.v({
  "blocks": "TalesOverlay-module-scss-module__AzNe8W__blocks",
  "close": "TalesOverlay-module-scss-module__AzNe8W__close",
  "fade-in": "TalesOverlay-module-scss-module__AzNe8W__fade-in",
  "footer": "TalesOverlay-module-scss-module__AzNe8W__footer",
  "inner": "TalesOverlay-module-scss-module__AzNe8W__inner",
  "isActive": "TalesOverlay-module-scss-module__AzNe8W__isActive",
  "isOverlayNavUse": "TalesOverlay-module-scss-module__AzNe8W__isOverlayNavUse",
  "nav": "TalesOverlay-module-scss-module__AzNe8W__nav",
  "navHeader": "TalesOverlay-module-scss-module__AzNe8W__navHeader",
  "navHeadline": "TalesOverlay-module-scss-module__AzNe8W__navHeadline",
  "navItem": "TalesOverlay-module-scss-module__AzNe8W__navItem",
  "navItemImage": "TalesOverlay-module-scss-module__AzNe8W__navItemImage",
  "navItemInner": "TalesOverlay-module-scss-module__AzNe8W__navItemInner",
  "navItemLockup": "TalesOverlay-module-scss-module__AzNe8W__navItemLockup",
  "navItemTitle": "TalesOverlay-module-scss-module__AzNe8W__navItemTitle",
  "navItems": "TalesOverlay-module-scss-module__AzNe8W__navItems",
  "overflow": "TalesOverlay-module-scss-module__AzNe8W__overflow",
  "root": "TalesOverlay-module-scss-module__AzNe8W__root",
});
